import React from "react";
import { useTranslation } from "react-i18next";
import JsonParentTable from "../Apps/Workflow/components/JsonTable";

function ModalLogsTab({ isLoading, executionDetails, activeStep, onStepChange }) {
    const { t } = useTranslation();

    if (isLoading) {
        return (
            <div className="space-y-3 p-6">
                <div className="animate-pulse h-6 w-40 bg-gray-200 rounded" />
                <div className="animate-pulse h-32 bg-gray-200 rounded" />
            </div>
        );
    }

    const rawLogs = executionDetails?.data?.logs;

    // Normalize: new format is { stepId: [...] }, legacy is array indexed by position
    const logEntries = React.useMemo(() => {
        if (!rawLogs) return [];
        if (Array.isArray(rawLogs)) return rawLogs.map((log, i) => ({ key: i, log }));
        if (typeof rawLogs === "object") return Object.entries(rawLogs).map(([key, log]) => ({ key, log }));
        return [];
    }, [rawLogs]);

    if (logEntries.length === 0) {
        return (
            <div className="text-center py-8 text-gray-500">
                <p>{t("monitoring.modal.noLogs")}</p>
            </div>
        );
    }

    const activeLog = logEntries[activeStep]?.log;

    return (
        <div className="h-full flex flex-col">
            <div className="p-4 border-b">
                <h3 className="font-medium text-sm text-gray-500 mb-2">
                    {t("monitoring.modal.availableSteps")}
                </h3>
                <div className="flex flex-wrap gap-1">
                    {logEntries.map((_, i) => (
                        <div
                            key={i}
                            onClick={() => onStepChange(i)}
                            className={`px-3 py-1 rounded-full text-xs cursor-pointer ${
                                i === activeStep
                                    ? "bg-primary text-primary-foreground"
                                    : "bg-muted hover:bg-muted/80"
                            }`}
                        >
                            {t("monitoring.modal.step")} {i + 1}
                        </div>
                    ))}
                </div>
            </div>
            <div className="flex-1 pr-6 overflow-scroll h-full">
                <div className="p-4">
                    {activeLog ? (
                        <div className="space-y-4">
                            <h4 className="font-medium text-lg">
                                {t("monitoring.modal.step")} {activeStep + 1} {t("monitoring.modal.logs")}
                            </h4>
                            <JsonParentTable data={activeLog} />
                        </div>
                    ) : (
                        <div className="text-center py-8 text-gray-500">
                            <p>{t("monitoring.modal.noStepLogs", { step: activeStep + 1 })}</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ModalLogsTab;
